var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.28px",
    height: "841.89px",
    viewBox: "0 0 595.28 841.89",
    enableBackground: "new 0 0 595.28 841.89",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.815,
    y: 311.615,
    fill: "#FFFFFF",
    width: 478.449,
    height: 106.666
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomouticon);
export default __webpack_public_path__ + "static/media/Zoomouticon.cdb12902714d2daa9db2579528b8a418.svg";
export { ForwardRef as ReactComponent };